import React from 'react'
import defaultStyles from './SimpleInput.module.scss'

const SimpleInput = ({
	inputLabel,
	isLabel = true,
	inputVariable,
	inputPlaceholder,
	onChange,
	styleMode = defaultStyles,
}) => {
	const handleChange = (e) => {
		onChange(e)
	}

	return (
		<div className={styleMode.flexCol}>
			<div className={isLabel ? styleMode.inputLabel : styleMode.none}>{inputLabel}</div>
			<div className={styleMode.inputBox}>
				<input
					placeholder={inputPlaceholder}
					type="text"
					value={inputVariable}
					onChange={(e) => handleChange(e)}></input>
				<div className={styleMode.suffix}>원</div>
			</div>
		</div>
	)
}

export default SimpleInput
